<div>
  <button *ngIf="type == 'page'" class="btn-add mb-2" (click)="addData()">
    <span>{{'them_du_lieu_moi' | translate}}</span>
    <span class="ml-1" nz-icon nzType="plus-circle" nzTheme="outline"></span>
  </button>
  <nz-table #editRowTable nzBordered [nzData]="staticdata.data_list" [nzShowPagination]="false"
    [nzScroll]="{ x: '643px', y: '400px' }">
    <thead>
      <tr>
        <th nzWidth="40%">{{'nhan' | translate}}</th>
        <th nzWidth="40%">{{'gia_tri' | translate}}</th>
        <th nzWidth="20%" nzRight>{{'thao_tac' | translate}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of editRowTable.data">
        <td><input type="text" nz-input [(ngModel)]="data.label" (blur)="updateStaticData()" /></td>
        <td><input type="text" nz-input [(ngModel)]="data.value" (blur)="updateStaticData()" /></td>
        <td nzRight>
          <span style="color: red" nz-icon nzType="delete" nzTheme="outline" nz-popconfirm
            [nzPopconfirmTitle]="'xac_nhan_xoa' | translate" [nzOkText]="'dong_y' | translate"
            [nzCancelText]="'huy' | translate" (nzOnConfirm)="deleteRow(data._id)"></span>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>